export const appConstants = {
  LANGUAGE: {
    DEFAULT_LANGUAGE: "tc",
    SECOND_LANGUAGE: "en",
  },
};
